import { useState } from 'react';
import ActionButton from '../../../components/Buttons/ActionButton';
import TriggerButton from '../../../components/Buttons/TriggerButton';
import { useFormFields } from '../../../helpers/FormFields';
import { IdentityService } from '../../../services/Identity.Service';
import { StateInterface } from '../../../interfaces/Identity.d';
import { getPasswordValidationError, passwordPolicyDescription } from '../../../helpers/PasswordPolicy';

export default function Change({
  password,
  state,
  onChange,
}: {
  password: string;
  state: StateInterface | null;
  onChange: (mode: number) => void;
}) {
  const [fields, handleFieldChange] = useFormFields({ password1: '', password2: '' });
  const [buttonText, setButtonText] = useState<string>('Change');
  const [errorText, setErrorText] = useState<string>('');

  async function handleChange(event: any) {
    event.preventDefault();

    //Run thru validation
    if (validate() && buttonText === 'Change') {
      //Update state
      setButtonText('Changing...');

      const result = await IdentityService.updatePassword(`${state?.email}`, password, fields.password1);

      if (result.errorMessage) {
        setButtonText('Change');
        setErrorText(result.errorMessage);
      } else {
        setErrorText('');
        IdentityService.expungeToken();
        window.location.href = '/Login';
      }
    }
  }

  function validate() {
    const validationError = getPasswordValidationError(fields.password1, fields.password2);
    setErrorText(validationError);
    return !validationError;
  }

  return (
    <>
      <span className="no-pad">
        {passwordPolicyDescription}
      </span>
      <form onSubmit={handleChange}>
        <div className="group">
          <p>New Password:</p>
          <input
            id="password1"
            className="input"
            autoFocus
            type="password"
            value={fields.password1}
            onChange={handleFieldChange}
          />
        </div>
        <div className="group">
          <p>Confirm Password:</p>
          <input
            id="password2"
            className="input"
            type="password"
            value={fields.password2}
            onChange={handleFieldChange}
          />
        </div>
        <span className="error">{errorText}</span>
        <div className="actions">
          <ActionButton type="submit" className="full-width offset" label={buttonText}></ActionButton>
          <TriggerButton
            label="Cancel"
            theme="light"
            disabled={false}
            onClick={() => {
              onChange(1);
            }}></TriggerButton>
        </div>
      </form>
    </>
  );
}
